enum AutomationTokenTypes {
  Expression = 'Expression', // User defined expressions
  LogicalOperator = 'LogicalOperator', // And, Or, Not
  RelationalOperator = 'RelationalOperator', // >, <, ==, !=, etc
  ArithmeticOperator = 'ArithmeticOperator', // +, -, *, /
  Bracket = 'Bracket', // (, )
}
enum LogicalOperators {
  And = 'and',
  Or = 'or',
  Not = 'not',
}
enum BracketTokens {
  OpenBracket = '(',
  CloseBracket = ')',
}
enum ExpressionTypes {
  Equal = 'eq',
  GreaterThan = 'gt',
  GreaterThanOrEqual = 'gte',
  LessThan = 'lt',
  LessThanOrEqual = 'lte',
  Contains = 'in',
  Any = 'any',
  Range = 'in_range',
  ValueJson = 'value_json',
  ValueNumeric = 'value_numeric',
  ValueString = 'value_string',
  ValueBoolean = 'value_boolean',
  ValueDateTime = 'value_datetime',
  ValueTimeSpan = 'value_timespan',
  ValueProperty = 'value_property',
}
enum ArithmeticOperators {
  Add = '+',
  Subtract = '-',
  Multiply = '*',
  Divide = '/',
}
enum RelationalOperators {
  GreaterThan = '>',
  GreaterThanOrEqual = '>=',
  LessThan = '<',
  LessThanOrEqual = '<=',
  Equal = '==',
  NotEqual = '!=',
}
enum EffectTypes {
  Assign = 'assign',
  AssignFromSource = 'assign_from_source',
  AddOrUpdate = 'add_or_update',
}
enum AutomationInputTypes {
  Number = 'number',
  Text = 'text',
  Boolean = 'boolean',
  DateTime = 'dateTime',
  TimeSpan = 'timeSpan',
  Property = 'property',
  Json = 'json',
  Select = 'select',
}

export {
  ArithmeticOperators,
  AutomationInputTypes,
  AutomationTokenTypes,
  BracketTokens,
  ExpressionTypes,
  EffectTypes,
  LogicalOperators,
  RelationalOperators,
};

export type VerifyEffectTypes = Utils.VerifyExtends<
  Model.Enum.Automation.EffectTypes,
  Utils.ValueOf<typeof EffectTypes>
>;
export type VerifyAutomationInputTypes = Utils.VerifyExtends<
  Model.Enum.Automation.AutomationInputTypes,
  Utils.ValueOf<typeof AutomationInputTypes>
>;
export type VerifyExpressionTypes = Utils.VerifyExtends<
  Model.Enum.Automation.ExpressionTypes,
  Utils.ValueOf<typeof ExpressionTypes>
>;
export type VerifyAutomationTokenTypes = Utils.VerifyExtends<
  Model.Enum.Automation.AutomationTokenTypes,
  Utils.ValueOf<typeof AutomationTokenTypes>
>;
export type VerifyBracketTokens = Utils.VerifyExtends<
  Model.Enum.Automation.BracketTokens,
  Utils.ValueOf<typeof BracketTokens>
>;
export type VerifyLogicalOperators = Utils.VerifyExtends<
  Model.Enum.Automation.LogicalOperators,
  Utils.ValueOf<typeof LogicalOperators>
>;
export type VerifyArithmeticOperators = Utils.VerifyExtends<
  Model.Enum.Automation.ArithmeticOperators,
  Utils.ValueOf<typeof ArithmeticOperators>
>;
export type VerifyRelationalOperators = Utils.VerifyExtends<
  Model.Enum.Automation.RelationalOperators,
  Utils.ValueOf<typeof RelationalOperators>
>;
